<template>
  <div>
    <div class="uk-section">

        <slider-show/>
        <ArticlesList 
          style="margin-top: 20px"
          :articles="portadas"
        />
        <LogosList />
      </div>

  </div>
</template>

<script>
import ArticlesList from "./ArticlesList";
import SliderShow from "../components/SliderShow"
import LogosList from "../components/LogosList"
import gql from "graphql-tag";

export default {
  components: {
    ArticlesList,
    SliderShow,
    LogosList
  },
  data() {
    return {
      portadas: []
    };
  },
  apollo: {
    portadas: gql`
      query{
        portadas: pages(where: {
          on_cover: true
        }){
          title
          slug
          summary
          category{
            name
            class{
              name
            }
          }
          cover{
            formats
          }
        }
      }
    `
  }
};
</script>